/*
 * @Author: Dong
 * @Date: 2022-04-12 16:29:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-22 14:28:39
 */
import request from 'root/utils/request';
import { INoticeType, IRecipientType, IRecipientParamsType } from 'root/pages/WarnNotification/types';

// 获取通知设置详情
export const getNoticeApi = async () => {
  return request.get('/api/ops-manager/v1/supos/alert/mail');
};

// 修改通知设置
export const updateNoticeApi = async (data: INoticeType) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/supos/alert/mail`,
    data,
  });
};

// 通知测试链接
export const testNoticeApi = async (data: INoticeType) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/supos/alert/mail_test`,
    data,
  });
};

// 获取收件人列表详情
export const getRecipientApi = async (data: IRecipientParamsType) => {
  return request.get('/api/ops-manager/v1/supos/alert/mail_inform', {
    params: { ...data },
  });
};

// 新增与编辑收件人
export const updateRecipientApi = async (data: IRecipientType) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/supos/alert/mail_inform`,
    data,
  });
};

// 删除收件人
export const delRecipientApi = async (data: string[]) => {
  return request({
    method: 'delete',
    url: `/api/ops-manager/v1/supos/alert/mail_inform`,
    data,
  });
};
// 配置系统维护通知
export const setSystemNotifications = async (params: any) => {
  return request.post('/api/ops-manager/v1/supos/notice/config', params);
};

// 获取系统维护配置通知信息
export const getSystemNotifications = async () => {
  return request.get('/api/ops-manager/v1/supos/notice/config');
};

// 发送测试邮件(根据邮箱id发送)
export const mailsendTestApi = async (data: string[]) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/supos/alert/mail_inform_test`,
    data,
  });
};
// 告警邮箱7天后再提醒
export const nextTimeApi = async () => {
  return request.post('/api/ops-manager/v1/supos/alert/remind/me/again/next/time');
};

// 告警检查
export const alertCheckApi = async () => {
  return request.get('/api/ops-manager/v1/supos/runtime_env/strong/reminder/window/check');
};

// 关键服务一键开启
export const oneClickApi = async () => {
  return request.post('/api/ops-manager/v1/supos/alert/enable/critical_alarm');
};

// 暂不开启关键服务
export const canleAlertApi = async () => {
  return request.get('/api/ops-manager/v1/supos/runtime_env/cancel/act_alarm');
};
